import { Navigate, useLocation } from 'react-router-dom';
import { profilePath } from '../routes/slugs';

/** `/notificaciones` (ya no es una pantalla: Notificaciones vive en Perfil) → `/profile/notificaciones`, conservando el query. */
export function PwaNotificacionesRedirect() {
  const { search } = useLocation();
  return <Navigate to={`${profilePath('notifications')}${search}`} replace />;
}
